import { postRequest } from "./main";

export function sendAccountInfo(data) {
    return postRequest('/auth/createaccount', data);
};

export function loginUser(data) {
    return postRequest('/auth/signin', data);
};